import { getAccountingRedirectUrl } from 'client/api/accounting'
import { useTypedSelector } from 'client/reducer'
import { clearSession } from 'client/utils'
import { useCallback, useEffect, useState } from 'react'

// these are the "view" query param values that are recognized by
// the Ageras/Billy app and can be translated to relevant routes there
export enum AccountingViews {
  SettingsVatRates = 'vat-rates-settings',
  Invoice = 'invoice',
  EInvoice = 'e-invoicing',
}

export type HandleAccountingNavigation = (view?: AccountingViews, invoiceId?: number) => void
interface UseAccountingNavigationResult {
  redirectUrl: string | null
  handleAccountingNavigation: HandleAccountingNavigation
}

// groupTwoAccess is used for super navigation bar
const useAccountingNavigation = (agerasNextMigration: boolean): UseAccountingNavigationResult => {
  const { token } = useTypedSelector((state) => state.token)

  const [redirectUrl, setRedirectUrl] = useState<string>('')

  const fetchRedirectUrl = useCallback(async () => {
    try {
      const redirectUrlData = await getAccountingRedirectUrl()
      setRedirectUrl(redirectUrlData?.redirectUrl || '')
    } catch (error) {
      console.error(error)
    }
  }, [setRedirectUrl])

  useEffect(() => {
    if (agerasNextMigration && !redirectUrl) {
      fetchRedirectUrl()
    }
  }, [agerasNextMigration, redirectUrl, fetchRedirectUrl])

  const handleAccountingNavigation: HandleAccountingNavigation = (view, invoiceId) => {
    if (redirectUrl) {
      const url = new URL(redirectUrl)
      if (view) {
        url.searchParams.append('view', view)

        if (view === AccountingViews.Invoice && invoiceId) {
          url.searchParams.append('invoiceId', String(invoiceId))
        }
      }
      url.searchParams.append('externalToken', token)

      clearSession()

      window.open(url.toString(), '_self')
    }
  }

  return { redirectUrl, handleAccountingNavigation }
}

export default useAccountingNavigation
